import React from "react";
import '../../styles/components/difficulty-navigation/difficulty-navigation.scss';
import {DifficultyOption} from "../../models/view/common/DifficultyOption";
import {FontIcon, Icon} from "../common/FontIcon";
import {createBootcampUrl, getCourseIdFromDifficultyOption} from "../../factories/bootCampPageFactory";
import { NavLink } from "react-router-dom";

interface IDifficultyNavigationProps {
  difficultyNavigationOptions: DifficultyOption[],
  currentlySelectedDifficultyOption: DifficultyOption,
}

export default function DifficultyNavigation({difficultyNavigationOptions, currentlySelectedDifficultyOption}: IDifficultyNavigationProps) {
  const difficultyOptionEls = difficultyNavigationOptions.map(d => createDifficultyOptionEl(d, currentlySelectedDifficultyOption));
  const difficultyClassName = currentlySelectedDifficultyOption;
  return (
    <div className={`difficulty-navigation ${difficultyClassName}`}>
      {difficultyOptionEls}
    </div>
  );
}

function createDifficultyOptionEl(difficultyOption: DifficultyOption, currentlySelectedDifficultyOption: DifficultyOption){
  const iconEl = createIconEl(difficultyOption);
  const selectedClassName = difficultyOption === currentlySelectedDifficultyOption ? `selected` : ``;
  const courseId = getCourseIdFromDifficultyOption(difficultyOption);
  const url = createBootcampUrl(courseId);
  return <NavLink to={url} replace className="difficulty-option-container" key={`difficulty-option-${difficultyOption}`}>
    <div className={`difficulty-option ${selectedClassName}`}>
      <div className={`icon-and-text`}>
        {iconEl}
        <span>{difficultyOption}</span>
      </div>
      <div className={`marker`}>&nbsp;</div>
    </div>
  </NavLink>;
}

function createIconEl(difficultyOption: DifficultyOption){
  let iconClassname:Icon = "icon-difficulty-rookie-compact";
  switch (difficultyOption) {
    case "all":
      iconClassname = "icon-difficulty-all-compact";
      break;
    case "rookie":
      iconClassname = "icon-difficulty-rookie-compact";
      break;
    case "intermediate":
      iconClassname = "icon-difficulty-intermediate-compact";
      break;
    case "advanced":
      iconClassname = "icon-difficulty-advanced";
      break;
  }

  return <FontIcon icon={iconClassname}/>
}
